import { FLink, SaldoCard, WideAlert } from '@components';
import { mdiBellRingOutline, mdiViewGridPlusOutline } from '@mdi/js';
import { Masonry } from '@mui/lab';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { recuperaPersonalizacaoRequest } from '../../../store/modules/personalizacaoHome/actions';
import Icons from '../Icon';
import { BeneficiosCard } from './Beneficios';
import { ContribuicoesCard } from './ContribuicoesHome';
import { EmprestimosCard } from './Emprestimos';
import { FaleConoscoCard } from './FaleConosco';
import { InstitutosCard } from './Institutos';
import { InvestimentosCard } from './Investimentos';
import { OutrosCard } from './Outros';
import { SaudeFinanceiraCard } from './SaudeFinanceira';
import { TransparenciaCard } from './Transparencia';
import { DadosPessoaisCard } from './MeusDados';
import { AtendimentoVirtualCard } from './AtendimentoVirtual';
// import { ExtratoContaCard } from './ExtratoConta';

export const CardHome = ({ isHomePage }) => {
  const dispatch = useDispatch();
  const [numColunas, setNumColunas] = useState(3);
  const users = useSelector((state) => state.user);
  const customizaHome = useSelector((state) => state.customizaHome);
  const custom = useSelector((state) => state.customizaSistema);
  const {
    tabela_contribuicao: showTabelaContribuicao,
    grafico_rendimento: showRendimentos,
    alterar_perfil: showPerfil,
    transformacao_reserva: showTransformacaoReserva,
    saque_vista: showSaqueVista,
    reserva_matematica: showReservaMatematica,
    alterar_recebimento: showAlterarRecebimento,
    parcela_adicional: showParcelaAdicional,
    memoria_calculo: showMemoriaCalculo,
    informe_rendimento: showInforme,
    simular_conversao_beneficio: showConversao,
    contracheque: showContracheque,
    simular_beneficio: showBeneficio,
    notificacao_participante: showNotificacaoParticipante,
    saude_financeira: showSaudeFinanceira,
    resgate_parcial: showResgateParcial,
    // extrato_aposentadoria: showExtratoAposentadoria,
  } = useSelector((state) => state.telasDisponiveis);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200 && window.innerWidth >= 768)
        setNumColunas(2);
      else if (window.innerWidth < 768) setNumColunas(1);
      else setNumColunas(3);
    };

    window.addEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (users.matricula >= '0' && users.plano >= '0') {
      dispatch(
        recuperaPersonalizacaoRequest({
          matricula: users.matricula,
          plano: users.plano,
        })
      );
    }
  }, [users.matricula, users.plano, dispatch]);

  return (
    <>
      <div>
        {showNotificacaoParticipante && (
          <div className="row mb-4 me-xl-2">
            <div className="col-12">
              <WideAlert className="mb-4 me-xl-2" iconClear>
                <div className="d-block d-lg-flex align-items-center">
                  <Icons
                    path={mdiBellRingOutline}
                    size={2}
                    style={{ marginRight: 20 }}
                  />
                  <p className="ts-16">
                    <strong>Queremos escutar você!</strong> A Forluz está
                    realizando uma pesquisa exclusiva com os participantes do
                    seu perfil, por isso, ouvir você é a nossa prioridade.{' '}
                    <a
                      href="https://bit.ly/Pesquisa_Forluz_A_Participante"
                      className="linkHome"
                    >
                      Responda agora
                    </a>
                  </p>
                </div>
              </WideAlert>
            </div>
          </div>
        )}
      </div>
      <div data-tour="step-3">
        <Masonry columns={1} spacing={2}>
          <div className="col-12">
            <AtendimentoVirtualCard />
          </div>
          {showRendimentos && !!customizaHome.saldo === !!isHomePage && (
            <div className="col-12">
              <SaldoCard />
            </div>
          )}
        </Masonry>
        <Masonry columns={numColunas} spacing={2}>
          <div className="col-12">
            <DadosPessoaisCard />
          </div>
          {showTabelaContribuicao &&
            !!customizaHome.contribuicoes === !!isHomePage && (
              <div className="col-12">
                <ContribuicoesCard />
              </div>
            )}
          {(showTransformacaoReserva ||
            showSaqueVista ||
            showReservaMatematica ||
            showAlterarRecebimento ||
            showParcelaAdicional ||
            showMemoriaCalculo ||
            showInforme ||
            showConversao ||
            showContracheque ||
            showBeneficio) &&
            !!customizaHome.simulador === !!isHomePage && (
              <div className="col-12">
                <BeneficiosCard />
              </div>
            )}
          {showSaudeFinanceira && (
            <div className="col-12">
              <SaudeFinanceiraCard />
            </div>
          )}
          {!!customizaHome.simularContratar === !!isHomePage && (
            <div className="col-12">
              <EmprestimosCard />
            </div>
          )}
          {/* {showContracheque && !!customizaHome.contracheque === !!isHomePage && (
            <div className="col-12">
              <ContrachequeCard />
            </div>
          )} */}
          {/* showExtratoAposentadoria &&
      !!customizaHome.cardExtratoConta === !!isHomePage && (
        <div className="col-12">
          <ExtratoContaCard />
        </div>
      ) */}
          {showPerfil && !!customizaHome.investimentos === !!isHomePage && (
            <div className="col-12">
              <InvestimentosCard />
            </div>
          )}

          {showResgateParcial && (
            <div className="col-12">
              <InstitutosCard />
            </div>
          )}

          {!!customizaHome.outros === !!isHomePage && (
            <div className="col-12">
              <OutrosCard />
            </div>
          )}

          {!!customizaHome.transparencia === !!isHomePage && (
            <div className="col-12">
              <TransparenciaCard />
            </div>
          )}

          {!!customizaHome.faleConosco === !!isHomePage && (
            <div className="col-12" data-tour="step-5">
              <FaleConoscoCard />
            </div>
          )}

          <div className="col-12" data-tour="step-4">
            <div className="card">
              <div className="card-body">
                <Icons
                  path={mdiViewGridPlusOutline}
                  color={custom.codCorLaranja}
                  size={2}
                  style={{ marginBottom: 10 }}
                />

                <h1 className="ts-20 fw-bold mb-2">
                  O que você quer ver em sua página inicial?
                </h1>
                <p className="ts-14 text-muted mb-0 mb-md-32">
                  Escolha os itens que devem ser exibidos primeiro.
                </p>
              </div>
              <div className="card-footer">
                <hr />
                <FLink className="mt-4" to="/personalizacao" icon>
                  Personalizar
                </FLink>
              </div>
            </div>
          </div>
        </Masonry>
      </div>
    </>
  );
};
